import { HttpContext } from '@angular/common/http';

import { CREATE_ENTITY_REQUEST_CONFIG, CreateEntityWidgetConfig } from '../config/create-entity-widget-config.types';

/** `${jemmaBaseUrl}/api/v1/secure`, tolerant of any number of trailing slashes on the host-supplied base URL. */
export function jemmaSecureBaseUrl(config: CreateEntityWidgetConfig): string {
    return `${config.jemmaBaseUrl.replace(/\/+$/, '')}/api/v1/secure`;
}

/** Stamps the calling widget instance's config on a request so `createEntityAuthInterceptor` can attach its headers. */
export function jemmaRequestContext(config: CreateEntityWidgetConfig): HttpContext {
    return new HttpContext().set(CREATE_ENTITY_REQUEST_CONFIG, config);
}
